import { useEffect, useState } from "react";
import { Input } from "components/ui/input";
import HelperText from "components/ui/helper-text";
import { emergencyFundAtom } from "lib/atoms";
import { useSetAtom } from "lib/global-context";
import { debounce } from "lodash";
import { cn, formatNumber } from "lib/utils";
import styles from "./input-emergency-fund.module.css";

interface InputEmergencyFundProps {
  config: {
    min: number;
    max: number;
    displayConfiguration: {
      type: string;
      title: string;
      name: string;
      helperText?: string;
    };
  };
}

const InputEmergencyFund = ({ config }: InputEmergencyFundProps) => {
  const { min, max, displayConfiguration } = config;
  const { type, title, name, helperText } = displayConfiguration;

  const setEmergencyFund = useSetAtom(emergencyFundAtom);
  const [tempValue, setTempValue] = useState<string>(
    (0).toLocaleString("en-US"),
  );

  const [error, setError] = useState<string | null>(null);

  const minValue = min;
  const maxValue = max;

  useEffect(() => {
    const numericValue = Number(tempValue.replace(/,/g, ""));
    if (!isNaN(numericValue)) {
      setEmergencyFund(numericValue);
    }
  }, [tempValue]);

  const validateEmergencyFund = debounce((value: string) => {
    const numericValue = Number(value.replace(/,/g, ""));
    if (numericValue < minValue) {
      setError(
        `Input an amount between S$${minValue.toLocaleString("en-US")} to S$${maxValue.toLocaleString("en-US")}`,
      );
    } else if (numericValue > maxValue) {
      setError(
        `Input an amount between S$${minValue.toLocaleString("en-US")} to S$${maxValue.toLocaleString("en-US")}`,
      );
    } else {
      setError(null);
      setEmergencyFund(numericValue);
    }
  }, 300);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (/^[0-9,]*$/.test(value)) {
      setTempValue(formatNumber(value));
      validateEmergencyFund(value);
    }
  };

  return (
    <div className={styles.container}>
      <label
        htmlFor={name}
        className={cn(styles.label, error && styles.labelError)}
      >
        {error || title}
      </label>
      <div className={styles.inputWrapper}>
        <span className={styles.currencySymbol}>S$</span>
        <Input
          id={name}
          type={type} // "text" instead of inputType "number"
          className={cn(styles.input, error && styles.inputError)}
          value={tempValue}
          onChange={handleChange}
          inputMode="numeric"
          pattern="[0-9,]*"
          required
        />
      </div>
      <HelperText>{helperText}</HelperText>
    </div>
  );
};

export default InputEmergencyFund;
